import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import { Toolbar, ToolbarGroup } from 'material-ui/Toolbar';
import compose from 'recompose/compose';
import withWidth from 'material-ui/utils/withWidth';
import {translate} from 'admin-on-rest';
import { styles } from './styles';


export class Pagination extends Component {
	range() {
		const input = [];
		const { page, perPage, total } = this.props;
		if (isNaN(page)) return input;
		const nbPages = Math.ceil(total / perPage) || 1;

		// display page links around the current page
		if (page > 2) {
				input.push('1');
		}
		if (page === 4) {
				input.push('2');
		}
		if (page > 4) {
				input.push('.');
		}
		if (page > 1) {
				input.push(page - 1);
		}
		input.push(page);
		if (page < nbPages) {
				input.push(page + 1);
		}
		if (page === (nbPages - 3)) {
				input.push(nbPages - 1);
		}
		if (page < (nbPages - 3)) {
				input.push('.');
		}
		if (page < (nbPages - 1)) {
				input.push(nbPages);
		}

		return input;
	}

	getNbPages() {
		return Math.ceil(this.props.total / this.props.perPage) || 1;
	}

	prevPage = (event) => {
		event.stopPropagation();
		if (this.props.page === 1) {
				throw new Error(this.props.translate('aor.navigation.page_out_from_begin'));
		}
		this.props.setPage(this.props.page - 1);
	}

	nextPage = (event) => {
		event.stopPropagation();
		if (this.props.page > this.getNbPages()) {
			throw new Error(this.props.translate('aor.navigation.page_out_from_end'));
		}
		this.props.setPage(this.props.page + 1);
	}

	gotoPage = (event) => {
		event.stopPropagation();
		const page = event.currentTarget.dataset.page;
		if (page < 1 || page > this.getNbPages()) {
			throw new Error(this.props.translate('aor.navigation.page_out_of_boundaries', { page }));
		}
		this.props.setPage(page);
	}

	renderPageNums() {
		return this.range().map((pageNum, index) =>
			(pageNum === '.') ?
				<span key={`hyphen_${index}`} style={{ padding: '1.2em' }}>&hellip;</span> :
				<FlatButton
					className="page-number"
					labelStyle={(pageNum === this.props.page)? styles.fontButtonSelected : styles.fontButton}
					key={pageNum}
					label={pageNum}
					data-page={pageNum}
					onClick={this.gotoPage}
					primary={pageNum !== this.props.page}
					backgroundColor={(pageNum === this.props.page)? "#E0610A" : "rgba(0, 0, 0, 0)"}
					hoverColor="rgba(98,98,98,0.35)"
					style={styles.buttonNumber} />
		);
	}

	render() {
		const { page, perPage, total, width } = this.props;
		if (total === 0) return null;
		const offsetEnd = Math.min(page * perPage, total);
		const offsetBegin = Math.min((page - 1) * perPage + 1, offsetEnd);
		const nbPages = this.getNbPages();

		return width === 1 ? (
			<Toolbar style={styles.container}>
				<ToolbarGroup style={styles.mobileToolbar}>
					<IconButton  onClick={this.prevPage} disabled={page <= 1} >
						<ChevronLeft color="#8F1800" />
					</IconButton>
					<span style={styles.pageInfo}>Showing {offsetBegin} to {offsetEnd} of {total} entries</span>
					<IconButton onClick={this.nextPage} disabled={page >= nbPages} >
						<ChevronRight color="#8F1800" />
					</IconButton>
				</ToolbarGroup>
		</Toolbar>
		) : (
			<Toolbar>
				<ToolbarGroup firstChild>
					<span className="displayed-records" style={styles.pageInfo}> Showing {offsetBegin} to {offsetEnd} of {total} entries</span>
				</ToolbarGroup>
				{nbPages > 1 &&
					<ToolbarGroup>
						<FlatButton className="previous-page"
							labelStyle={styles.fontButton}
							primary
							key="prev"
							label="Previous"
							icon={<ChevronLeft />}
							onClick={this.prevPage}
							style={styles.button}
							disabled={page <= 1} />
						{this.renderPageNums()}
						<FlatButton className="next-page"
							primary
							labelStyle={styles.fontButton}
							key="next"
							label="Next"
							icon={<ChevronRight />}
							labelPosition="before"
							onClick={this.nextPage}
							disabled={page >= nbPages}
							style={styles.button} />
					</ToolbarGroup>
					}
			</Toolbar>
		);
	}
}

Pagination.propTypes = {
	page: PropTypes.number,
	perPage: PropTypes.number,
	total: PropTypes.number,
	setPage: PropTypes.func,
	translate: PropTypes.func.isRequired,
	width: PropTypes.number,
};

const enhance = compose(
	pure,
	translate,
	withWidth(),
);

export default enhance(Pagination);


// WEBPACK FOOTER //
// ./src/components/pagination/index.js